export const GET_ALL_USERS = 'GET_ALL_USERS';
export const UPDATE_ACTIVE_USERS = 'UPDATE_ACTIVE_USERS';
export const CLEAR_ACTIVE_USERS = 'CLEAR_ACTIVE_USERS';
